import Action from '../action'
import { openRoute } from '../actions/routes'

type State = {
  identifier?: string
}

export default (state: State = {}, action: Action): State => {
  switch (action.type) {
    case openRoute.type:
      return { ...state, identifier: action.identifier }
    default:
      return state
  }
}
